import { SET_SUBTITLE } from '@constants/ActionTypes';

export const setSubtitle = (subtitle) => {
  return {
    type: SET_SUBTITLE,
    langId: subtitle,
  }
};